



















import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { NavBar, Cell, CellGroup, Button, Image } from "vant";
import WeMixin from "@/components/weMixin";
import Jssdk, { WxJsapiSignature } from "@/components/wechat/wechatJssdkMixin";

import vueQr from "vue-qr";
Vue.use(vueQr);

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Image.name]: Image,
  },
})
export default class YhfflToYMT extends mixins(WeMixin, Jssdk) {
  private qrCodeText: string = "";

  protected created() {
    this.qrCodeText =
      "https://wap.psbc.com/sz/static/h5/cloud/index.html?cssver=1706498850.701795#/code_home?z=17002ED6A2FB7AE2957F79182A9FA223";
  }
}
